/* eslint-disable */
import React from 'react'
import { Skeleton } from 'antd'

/** 与 NewOrdersDispatchMobilePage 首屏一致，供 ClientOutletGuard / ClientDefaultRedirect 复用，避免权限加载与业务加载两套 UI */
const TITLE = { width: '36%' }
const PARAGRAPH = { rows: 10 }

export default function ClientRouteBootSkeleton () {
  return (
    <div className="client-route-boot-skeleton">
      <div className="client-route-boot-skeleton__inner">
        <Skeleton active title={TITLE} paragraph={PARAGRAPH} />
      </div>
    </div>
  )
}
